<template>
  <div>
    <v-row>
      <v-col cols="12" v-if="informText != ''">
        <v-alert type="error">{{ informText }}</v-alert>
      </v-col>

      <v-col cols="4">
        <v-text-field
          label="Package Name"
          v-model="packageData.package_name"
          dense
          outlined
          hide-details
        ></v-text-field>
      </v-col>

      <v-col cols="4">
        <v-select
          :items="supplierData"
          :item-text="(obj) => obj.vendor_code"
          :item-value="(obj) => obj.vendor_code"
          v-model="packageData.supplier"
          outlined
          hide-details
          dense
          label="Supplier"
        ></v-select>
      </v-col>

      <v-col cols="4">
        <v-text-field
          label="Base Cost"
          v-model="packageData.base_cost"
          type="number"
          hide-details
          dense
          outlined
        ></v-text-field>
      </v-col>

      <v-col><v-btn @click="addProd()" color="info">Add Product</v-btn></v-col>

      <v-col cols="12">
        <table width="100%" class="table">
          <tr v-for="(i, index) of packageData.products" :key="index">
            <td width="30%">
              <v-text-field
                label="Product Code"
                dense
                outlined
                hide-details
                v-model="i.product_code"
              ></v-text-field>
            </td>
            <td width="30%">
              <v-text-field
                label="Variant"
                dense
                outlined
                hide-details
                v-model="i.variant_id"
              ></v-text-field>
            </td>
            <td width="30%">
              <v-text-field
                label="Quantity"
                type="number"
                dense
                outlined
                hide-details
                v-model="i.quantity"
              ></v-text-field>
            </td>
            <td width="10%">
              <v-btn color="red" dark @click="delProd(i)"
                ><v-icon>mdi-delete</v-icon></v-btn
              >
            </td>
          </tr>
        </table>
      </v-col>
    </v-row>

    <v-btn @click="saveData" color="success" dark v-if="roles.create_package"
      >Save</v-btn
    >
    <v-btn color="success" disabled v-else>Save</v-btn>
    &nbsp;
    <v-btn @click="cancelData()" color="orange" dark>Close</v-btn>
  </div>
</template>

<script>
import axios from "axios";
import Amplify from "aws-amplify";

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

export default {
  name: "PackageCreate",

  props: {
    supplierData: Array,
  },

  data: () => ({
    packageData: {
      package_name: "",
      products: [],
      supplier: "",
      base_cost: 0,
    },

    informText: "",
    roles: [],
  }),

  methods: {
    cancelData(reload) {
      if (reload) {
        this.$root.$refs.packageList.turnOffDialog(true);
      } else {
        this.$root.$refs.packageList.turnOffDialog();
      }
    },

    addProd() {
      var item = {
        product_code: "",
        variant_id: "",
        quantity: 0,
      };
      this.packageData.products.push(item);
    },

    delProd(item) {
      this.packageData.products = this.packageData.products.filter(
        (t) => t != item
      );
    },

    async saveData() {
      var currentSession = await this.$root.$refs.App.currentSession(
        "package-saveData"
      );
      if (currentSession.accessToken) {
        await axios({
          method: "POST",
          url: window.domain + "packages",
          headers: { Authorization: currentSession.accessToken },
          data: this.packageData,
        }).then((response) => {
          console.log("response: ", response);
          if (response.data.error_message != "") {
            this.informText = response.data.error_message;
          } else {
            this.cancelData(true);
          }
        });
      }
    },
  },

  async mounted() {
    this.roles = await this.$cookies.get("package");
    if (this.roles.list_packages) {
      console.log("OK");
    } else {
      this.$router.push("/not-authorized");
    }
  },
};
</script>

<style lang="scss" scoped>
</style>